"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SystemCheck = require("./SystemCheck");
Object.keys(_SystemCheck).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SystemCheck[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SystemCheck[key];
    }
  });
});